import './loader.css';
// import { Broadcast, SpinnerGap } from "@phosphor-icons/react";

// export default function LoadingPage() {
//   return (
//     <div className="flex flex-col items-center justify-center min-h-screen bg-gray-body text-gray-dark px-5">
//       <Broadcast
//         size={96} 
//         weight="fill"
//         // weight="bold" 
//         className="text-primary-base animate-ping mb-6" 
//       />
//       <h1 className="text-2xl font-semibold mb-2 text-primary-base">
//         Loading...
//       </h1>
//       <p className="text-lg text-gray-semidark text-center">
//         Please wait while we load your content.
//       </p>
//     </div>
//   );
// }

export default function LoadingPage() {
  return (
    <div className='flex justify-center items-center h-screen'>

    <div id="wifi-loader">
      <svg viewBox="0 0 86 86" className="circle-outer">
        <circle r="40" cy="43" cx="43" className="back"></circle>
        <circle r="40" cy="43" cx="43" className="front"></circle>
        <circle r="40" cy="43" cx="43" className="new"></circle>
      </svg>
      <svg viewBox="0 0 60 60" className="circle-middle">
        <circle r="27" cy="30" cx="30" className="back"></circle>
        <circle r="27" cy="30" cx="30" className="front"></circle>
      </svg>
      <svg viewBox="0 0 34 34" className="circle-inner">
        <circle r="14" cy="17" cx="17" className="back"></circle>
        <circle r="14" cy="17" cx="17" className="front"></circle>
      </svg>
      <div data-text="Loading..." className="text"></div>
    </div>
    </div>

  );
}